import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/toggle-button-group/toggle-button-group.js';
      import {ObcToggleButtonOptionType, ObcToggleButtonOptionVariant} from '@oicl/openbridge-webcomponents/dist/components/toggle-button-option/toggle-button-option.js';

      export interface Props {
     value?: string;
     activated?: string | undefined;
     type?: ObcToggleButtonOptionType;
     variant?: ObcToggleButtonOptionVariant;
     hugText?: boolean;
     externalControl?: boolean;
     disabled?: boolean;
     large?: boolean
   }

      
  
      export type {ObcToggleButtonOptionType, ObcToggleButtonOptionVariant} from '@oicl/openbridge-webcomponents/dist/components/toggle-button-option/toggle-button-option.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcToggleButtonGroup',
  props: {
    value: {},
    activated: {},
    type: {},
    variant: {},
    hugText: { type: Boolean },
    externalControl: { type: Boolean },
    disabled: { type: Boolean },
    large: { type: Boolean }
  },
  emits: ["value"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onValue: (event: CustomEvent<{value: string, previousValue: string}>) => emit('value', event as CustomEvent<{value: string, previousValue: string}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-toggle-button-group',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})